import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { DownloadButton as StyledButton } from "./styles";

import useIconDownload from "frontend/hooks/useIconDownload";
import { useIconEditorState } from "js/contexts/IconEditorContext";
import { DOWNLOAD_TYPES } from "icons/helpers";

const DOWNLOAD_FEEDBACK_IN_MS = 3000;

const DownloadButton = ({
    downloadType,
    downloadSize,
    icon,
    onFail,
    onDownload
}) => {
    const state = useIconEditorState();

    const {
        startDownload,
        isStarted,
        isCompleted,
        hasFailed
    } = useIconDownload({
        downloadType,
        downloadSize,
        editorValues: state,
        icon
    });

    const [downloadInProgress, setDownloadInProgress] = useState(false);
    useEffect(() => {
        if (isStarted && !isCompleted && !downloadInProgress) {
            setDownloadInProgress(true);
            setTimeout(
                () => setDownloadInProgress(false),
                DOWNLOAD_FEEDBACK_IN_MS
            );
        }
    }, [isStarted, isCompleted, downloadInProgress]);

    useEffect(() => {
        if (hasFailed && typeof onFail === "function") {
            onFail();
        }
    }, [hasFailed]);

    useEffect(() => {
        if (isCompleted && typeof onDownload === "function") {
            onDownload();
        }
    }, [isCompleted]);

    return (
        <StyledButton
            isDisabled={downloadInProgress}
            isProcessing={downloadInProgress}
            onClick={startDownload}
        >
            Download {downloadType}
        </StyledButton>
    );
};

DownloadButton.propTypes = {
    downloadType: PropTypes.oneOf(DOWNLOAD_TYPES).isRequired,
    downloadSize: PropTypes.number.isRequired,
    icon: PropTypes.object.isRequired,
    onFail: PropTypes.func,
    onDownload: PropTypes.func
};

export default DownloadButton;
